import { BoundsShape, LngLatGeolocation } from 'ts-core';
import {
  bounds,
  viewport,
  BoundingBox as MapboxBoundingBox,
} from '@mapbox/geo-viewport';
import { BoundingBox } from 'ts-core';

export function convertInitialZoomLocationToBbox(
  initialZoom: number,
  initialLocation: LngLatGeolocation,
  dimensions: [number, number]
): BoundingBox {
  const b = bounds(
    { lat: initialLocation.lat, lon: initialLocation.lng },
    initialZoom,
    dimensions
  );
  return new BoundingBox({ lat: b[3], lng: b[2] }, { lat: b[1], lng: b[0] });
}

export function convertBBoxToZoomLocation(
  bbox:
    | BoundsShape
    | { northEast: LngLatGeolocation; southWest: LngLatGeolocation },
  dimensions: [number, number]
): { zoom: number; center: LngLatGeolocation } {
  const northEast = 'contains' in bbox ? bbox.getNorthEast() : bbox.northEast;
  const southWest = 'contains' in bbox ? bbox.getSouthWest() : bbox.southWest;
  const b: MapboxBoundingBox = [
    southWest.lng,
    southWest.lat,
    northEast.lng,
    northEast.lat,
  ];
  const v = viewport(b, dimensions);
  const roundTo = (value: number, decimals: number) =>
    Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  const roundedCenter = {
    lat: roundTo(v.center[1], 5),
    lng: roundTo(v.center[0], 5),
  };
  const roundedZoom = roundTo(v.zoom, 2);

  return {
    zoom: roundedZoom,
    center: roundedCenter,
  };
}
